import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CareGiversSliceState } from "../../types/store";
import { DEFAULT_TABLE_PAGINATION } from "../../constants/pagination";
import { CareGiver } from "../../types/caregivers";
import { TablePaginationConfig } from "../../types/common";

export const CARE_GIVERS_SLICE = 'caregivers' as const;

const initialState: CareGiversSliceState = {
  paginatedData: [],
  tablePaginationConfig: DEFAULT_TABLE_PAGINATION,
  totalNumberOfPages: 1,
}

export const caregiversSlice = createSlice({
  name: CARE_GIVERS_SLICE,
  initialState: initialState,
  reducers: {
    loadCareGiversPaginatedData: (
      state: CareGiversSliceState,
      { payload: data }: PayloadAction<CareGiver[]>
    ) => {
      state.paginatedData = data;
    },
    loadCareGiversTablePaginationConfig: (
      state: CareGiversSliceState,
      { payload: paginationConfig }: PayloadAction<TablePaginationConfig>
    ) => {  
      state.tablePaginationConfig = paginationConfig;
    },
    loadCareGiversTotalNumberOfPages: (
      state: CareGiversSliceState,
      { payload: numberOfPages }: PayloadAction<number>
    ) => {
      state.totalNumberOfPages = numberOfPages;
    }
  }
});

export const {
  loadCareGiversPaginatedData,
  loadCareGiversTablePaginationConfig,
  loadCareGiversTotalNumberOfPages
} = caregiversSlice.actions;

export default caregiversSlice.reducer;